import React, {Fragment, useEffect, useReducer, useState} from 'react';
import PropTypes from "prop-types";
import ModalContentWrapper from '../ModalContentWrapper';
import {useForm} from "react-hook-form";
import ErrorDiv from "root/ReactHookForm/ui/ErrorDiv";
import {getMisuseReportDetails} from "root/DataFunctions/SafeguardingDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import SpinnerDiv from "root/Components/SpinnerDiv";
import VanillaModal from "../VanillaModal/VanillaModal";

const ModalAddMisuseReport = (props) =>
{
    const [ buttonState, setButtonState ] = useState ('') ;
    const [data, setData] = useState({ isLoading: false, data: [] });

    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                misuse_report: {
                    name: '',
                    reported_user: '',
                    misuse_description: '',
                    date_reported: ''
                }
            }
        });

    const isFetchRequired = props.mode === 'edit' || props.mode === 'view' || props.mode === 'delete' ;

    const titles = {
        view: 'View Report Details',
    } ;

    const saveButtonText = {
        view: 'Close',
        edit: 'Save Changes',
        create: 'Save',
        delete: 'Click To Delete'
    } ;

    useEffect(() =>
    {
        if ( isFetchRequired )
        {
            getMisuseReportDetails(props.misuse_report_id, (response) =>
            {
                const reportData = getDataFromResponse(response)[0] ;

                setValue('misuse_report', {
                    name: reportData.name,
                    reported_user: reportData.misuse_user_name,
                    misuse_description: reportData.misuse_description,
                    date_reported: reportData.formatted_date
                    }
                );

                setData({isLoading: false, data: reportData});
            });
        }
    }, [props.misuse_report_id]);

    const onSaveComplete = () =>
    {
        props.onSaveCompleted ('saved');
        props.onClose() ;
    }

    const onClickCancel = () =>
    {
        props.onSaveCompleted ('cancel');
        props.onClose() ;
    }

    const doSaveNew = ( data ) =>
    {
        createReport(data.misuse_report, onSaveComplete ) ;
    }

    const doSave = (data) =>
    {
        updateReport(props.misuse_report_id, data.misuse_report, onSaveComplete ) ;
    }

    const doDelete = ( onComplete ) =>
    {
        deleteReport( props.misuse_report_id, onSaveComplete ) ;
    }

    const onClickSave = (status) =>
    {
        handleSubmit(onSubmit)(status);
    }

    const confirmShow = (title, message, action) =>
    {
        let cfrm = new VanillaModal ({
            title: title,
            content: message,
            buttons: VanillaModal.buttons.confirm
        })

        cfrm.show().once('dismiss', (modal, ev, button) => {
            if (button && button.value === true)
            {
                action() ;
            }
        });
    }

    const onSubmit = (data) =>
    {
        disableButtons();

        switch (props.mode)
        {
            case 'create' :
                doSaveNew(data, onSaveComplete);
                break;
            case 'edit' :
                doSave(data, onSaveComplete);
                break;
            case 'delete' :
                confirmShow ('Delete Misuse Report', 'Are you sure you want to delete this misuse report?', result =>
                    {
                        doDelete();
                    })
                break;

            case 'view' :
                props.onSaveCompleted ('cancel');
                props.onClose() ;
                break;
        }
    }

    const disableButtons = () =>
    {
        setButtonState ('disabled');
    }

    const Title = ( props ) =>
    {
        return <h3>{titles[props.mode]}</h3>
    }

    const getSaveButtonText = ( mode ) =>
    {
        return saveButtonText[props.mode] ;
    }

    const getSaveButtonStyle= ( mode ) =>
    {
        switch ( mode )
        {
            case 'delete':
                return "btn btn-icon btn-danger btn-icon-right btn-small" ;
            default:
                return "btn btn-icon btn-primary btn-icon-right btn-small" ;
        }
    }

    const SaveButton = (props) =>
    {
        const clickHandler = buttonState === '' ? onClickSave : null;

        return (
            <button onClick={clickHandler} style={{marginRight: '10px', marginLeft: '10px'}} disabled={buttonState} className={getSaveButtonStyle(props.mode)}>{getSaveButtonText(props.mode)}<i className="et-save" /></button>
        )
    }

    const formContent = () =>
    {
        if ( data.isLoading === true )
        {
            return (
                <div style={{width: props.width}}>
                    <SpinnerDiv />
                </div>
            )
        }
        else
        {
            const isReadOnly = props.mode === 'view' || props.mode === 'delete' ;

            return (
                <Fragment>
                    <div className='buy-card-right'>
                        <form className='registration-form' onSubmit={handleSubmit(onSubmit)}>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div style={{marginBottom: '10px'}}>
                                        <label>Reported By</label>
                                        <input readOnly={isReadOnly} className='form-control' name='misuse_report.name'
                                               id='reported_by' {...register("misuse_report.name")} />
                                        {formErrors.misuse_report?.name && <ErrorDiv>Please enter a name</ErrorDiv>}
                                    </div>
                                </div>

                                <div className='col-md-6'>
                                    <div style={{marginBottom: '20px'}}>
                                        <label>Date Reported</label>
                                        <input readOnly={isReadOnly} className='form-control' name='misuse_report.date_reported'
                                               id='date_reported' {...register("misuse_report.date_reported")} />
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-6'>
                                    <div style={{marginBottom: '10px'}}>
                                        <label>Reported User</label>
                                        <input readOnly={isReadOnly} className='form-control' name='misuse_report.reported_user'
                                               id='reported_user' {...register("misuse_report.reported_user")} />
                                        {formErrors.misuse_report?.name && <ErrorDiv>Please enter a name</ErrorDiv>}
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12'>
                                    <div style={{marginBottom: '20px'}}>
                                        <label>Report Description</label>
                                        <textarea style={{minHeight: '10em'}} readOnly={isReadOnly} className='form-control' name='misuse_report.misuse_description'
                                               id='misuse_description' {...register("misuse_report.misuse_description")} />
                                        {formErrors.misuse_report?.misuse_description && <ErrorDiv>Please enter a description</ErrorDiv>}
                                    </div>
                                </div>
                            </div>


                        </form>
                    </div>

                    <div className="d-flex flex-row justify-content-end">
                        { props.mode !== 'view' && <button onClick={onClickCancel} className="btn btn-secondary">Cancel<i className="et-arrow-bold-left"/></button>}
                        <SaveButton mode={props.mode} onClick={onClickSave} />
                    </div>
                </Fragment>
            )
        }
    }

    return (
        <ModalContentWrapper className="modal-wrapper" width={'600px'} columns={2}>
            <Title mode={props.mode} />
            {formContent()}
        </ModalContentWrapper>
    )
}

export default ModalAddMisuseReport;

ModalAddMisuseReport.defaultProps =
{
    width: '600px',
    height:'800px'
}

ModalAddMisuseReport.propTypes = {
    team_id: PropTypes.string,
    width: PropTypes.string,
    mode: PropTypes.string.isRequired,
    onSaveCompleted: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
